import qs from 'qs';
import { Location } from '../model/entities';
import { proxyApiAxios } from './CustomAxios';
import providerAuthService from '../services/ProviderAuthService';

class LocationApi {
    list = async (hubId: string, projectId: string[]): Promise<Location[]> => {
        const headers = await providerAuthService.getRequestHeader('ACC');
        const response = await proxyApiAxios.get<Location[]>('/locations', {
            params: { hubId, projectId },
            paramsSerializer: (params) => {
                return qs.stringify(params, { arrayFormat: 'repeat' });
            },
            headers,
        });

        return response.data;
    };
}

const locationApi: LocationApi = new LocationApi();
export default locationApi;
